import { render } from "./Autocomplete.vue?vue&type=template&id=5465302e"
import script from "./Autocomplete.vue?vue&type=script&lang=js"
export * from "./Autocomplete.vue?vue&type=script&lang=js"

import exportComponent from "/home/grosscol/workspace/bravue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__